import { render } from "./subscribeNewsletter.vue?vue&type=template&id=61cf5330"
import script from "./subscribeNewsletter.vue?vue&type=script&lang=js"
export * from "./subscribeNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__